module.exports = __webpack_public_path__ + "static/media/NEMA6.570e70e7.pdf";